import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Select } from '../Select.js';
import { countries } from './countries.js';

const CountrySelect = React__default.forwardRef(({ ...attrs }, ref) => (jsxs(Select, { ...attrs, ref: ref, children: [jsx("option", { value: "", disabled: true, children: "Country" }), countries.map((country) => (jsx("option", { value: country.code, children: country.name }, country.code)))] })));
CountrySelect.displayName = "CountrySelect";

export { CountrySelect };
//# sourceMappingURL=CountrySelect.js.map
